<div class='content'>
    <app-header
        [user]='user'
        [isIris]='selectedChantierIsIris$ | async'
        [selectableChantiers]='selectableChantiers$ | async'
        [selectedChantier]='selectedChantier$ | async'
        [supportEmail]='supportEmail$ | async'
        [breadcrumbDatas]='breadcrumbDatas$ | async'
        [shouldDisplayAccesChantierButton]='shouldDisplayAccesChantierButton$ | async'
        [shouldDisplayBreadcrumbInHeader]='shouldDisplayBreadcrumbInHeader$ | async'
        [shouldDisplayChantierSelect]='shouldDisplayChantierSelect$ | async'
        [shouldDisplayEntiteComponent]='shouldDisplayEntiteComponent$ | async'
        [entiteCode]='entiteCode$ | async'
        [chantierCodeFromUrl]='chantierCodeFromUrl$ | async'
        [chantierFromUrl]='chantierFromUrl$ | async'
        [isChantierSelectorDisabled]='isChantierSelectorDisabled$ | async'
        [currentLogo]='currentLogo$ | async'
        (openSelectChantierModal)='openSelectChantierModal()'
        (logout)='logOut()'
        (selectChantier)='selectChantier($event)'
        (contactSupport)='onContactSupport()'
        (copyChantierToClipboard)='onCopyChantierToClipboard()'
        [hidden]='shouldDisplaySimplifiedInterface$ | async'

    />
    <router-outlet />
    <app-footer [supportEmail]='supportEmail$ | async'
                [backendVersion]='backendVersion$ | async'
                [shouldDisplayContactCSM]='shouldDisplayContactCSM$ | async'
                [hidden]='shouldDisplaySimplifiedInterface$ | async'
                [contactCsm]='contactCSM$ | async' />
</div>
